<mat-nav-list>
  <app-menu-item *ngFor="let item of navDataDisplay" [item]="item" [collapsed]="sideNavCollapsed()">
  </app-menu-item>
</mat-nav-list>
